/**
 * Filtra boletos de lote por texto libre.
 * @param {Array} lotTickets - Lista de boletos.
 * @param {string} searchTerm - Texto de búsqueda.
 * @returns {Array} Resultado filtrado.
 */
export const filterLotTickets = (lotTickets = [], searchTerm = '') => {
  if (!searchTerm) return lotTickets;

  const term = searchTerm.toLowerCase();
  return lotTickets.filter((ticket) => {
    const fullName = (ticket?.full_name || '').toLowerCase();
    const dni = (ticket?.dni || '').toLowerCase();
    const email = (ticket?.email || '').toLowerCase();
    const phone = (ticket?.phone_number || '').toLowerCase();
    return fullName.includes(term) || dni.includes(term) || email.includes(term) || phone.includes(term);
  });
};

/**
 * Genera un label corto para un lote.
 * @param {Object} lot - Lote del backend.
 * @returns {string} Label legible.
 */
export const getLotLabel = (lot, allotmentName = '') => {
  if (!lot) return 'Sin lote';
  const block = (lot.block_number || '').trim();
  const number = (lot.lot_number || '').trim();
  const lotLabel = `${block}${block ? ' ' : ''}${number}`.trim();
  const baseLabel = lotLabel || lot.uuid || 'Sin lote';
  if (allotmentName) {
    return `${allotmentName} - ${baseLabel}`;
  }
  return baseLabel;
};
